// Core
import React, { useEffect, useState } from "react";
//Import Scss
import "./styles.scss";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchSingleFailureAnalysisRequest } from "../../../../Redux/Slices/failureAnalysisReqSlice";
import ImageModal from "Components/ImageModal";

const MachineInformation = (farId) => {
  const [assetDetails, setAssetDetails] = useState({});
  const [bearingInfo, setBearingInfo] = useState({});
  const [bearingDetails, setBearingDetails] = useState([]);
  const [bearingFailureDetails, setBearingFailureDetails] = useState({});
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    getIndividualData();
  }, []);

  const getIndividualData = () => {
    dispatch(
      fetchSingleFailureAnalysisRequest({
        data: {
          remote_failure_details_id: id || farId.farId,
        },
        callBack: getAssetDetailsData,
      })
    );
  };

  const getAssetDetailsData = (data) => {
    setBearingFailureDetails(data?.result);
    setAssetDetails(data?.result?.remote_failure_asset_details);
    setBearingInfo(
      data?.result?.remote_failure_asset_details
        ?.remote_failure_bearing_info_details
    );
    setBearingDetails(
      data?.result?.remote_failure_asset_details
        ?.remote_failure_bearing_info_details?.remote_failure_bearing_details
    );
  };

  const bearingFailureData = [
    {label : "Application Or Position", value : bearingFailureDetails?.application_or_position},
    {label : "Failure Details", value : bearingFailureDetails?.failure_details},
    {label : "Consequences Of Failure", value : bearingFailureDetails?.consequences_of_failure},
    {label : "Addition Details", value : bearingFailureDetails?.additional_details},
  ] 

  const machineDetails = [
    { label: "Plant Area", value: assetDetails?.plant_area },
    { label: "Machine Type", value: assetDetails?.machine_type },
    {
      label: "Machine Part",
      value: assetDetails?.machine_part,
    },
    {
      label: "Maintenance History",
      value: assetDetails?.maintenance_history,
    },
    {
      label: "Original Equipment Manufacturer Name",
      value: assetDetails?.original_equipment_manufacturer_name,
    },
    {
      label: "OEM Model Number",
      value: assetDetails?.oem_model_number,
    },
    {
      label: "OEM Machine Serial",
      value: assetDetails?.oem_machine_serial,
    },
    {
      label: "End User Tag Number",
      value: assetDetails?.end_user_tag_number,
    },
    {
      label: "Additional Details",
      value: assetDetails?.additional_details,
    },
  ];

  const bearingInfoDetails = [
    { label: "No.of Bearings", value: bearingInfo?.number_of_bearings_name },
  ];

  return (
    <div className="DetailsContainer">
      <div className="DetailsSection">
        <h2>Asset Details</h2>
        <div className="details" >
          <div className="DetailsLabel" style={{marginBottom:"20px"}}>Application Drawings:</div>
          <div style={{marginBottom:"20px"}}>
            {assetDetails?.upload_application_drawings ? (
              // <img style={{height:"150px",width:"150px"}} src={assetDetails?.upload_application_drawings} alt="set" />
              <ImageModal
               src={assetDetails?.upload_application_drawings}
               alt="set"
               isDeleteReq = {false}
               />
            ) : (
              <div className="DetailsValue">-</div>
            )}
          </div>
        </div>

        {machineDetails.map((item, index) => (
          <div className="DetailsRow" key={index}>
            <div className="DetailsLabel">{item.label}</div>
            <div className="DetailsValue">: {item.value}</div>
          </div>
        ))}
      </div>
      <div className="DetailsSection">
        <h2>Bearing Information</h2>
        {bearingInfoDetails.slice().reverse().map((item, index) => (
          <div className="DetailsRow" key={index}>
            <div className="DetailsLabel">{item.label}</div>
            <div className="DetailsValue">: {item.value}</div>
          </div>
        ))}
      </div>
      <div>
        {bearingDetails?.slice().reverse().map((item, index) => {
          return (
            <div className="DetailsSection" key={index}>
              <h2>Bearing {index + 1}</h2>
              <div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Bearing Type</div>
                  <div className="DetailsValue">: {item.bearing_type_name}</div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Bearing Designation</div>
                  <div className="DetailsValue">
                    : {item.bearing_designation}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Bearing Make</div>
                  <div className="DetailsValue">: {item.bearing_make}</div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">
                    Bearing History (If Available)
                  </div>
                  <div className="DetailsValue">: {item.bearing_history}</div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Rotational Speed (r/min)</div>
                  <div className="DetailsValue">: {item.rotational_speed}</div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Ring Rotation</div>
                  <div className="DetailsValue">
                    : {item.ring_rotation_name}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Axial Load</div>
                  <div className="DetailsValue">: {item.axial_load}</div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Radial Load</div>
                  <div className="DetailsValue">: {item.radial_load}</div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">
                    Bearing Operating Temperature
                  </div>
                  <div className="DetailsValue">
                    : {item.bearing_operating_temperature}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Ambient Temperature</div>
                  <div className="DetailsValue">
                    : {item.ambient_temperature}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">
                    Environment Contamination Level
                  </div>
                  <div className="DetailsValue">
                    : {item.environment_contamination_level_name}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Vibration Level</div>
                  <div className="DetailsValue">
                    : {item.vibration_level_name}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Humidity/Moisture Level</div>
                  <div className="DetailsValue">
                    : {item.humidity_moisture_level_name}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Operating Hours</div>
                  <div className="DetailsValue">
                    : {item.operating_hours_name}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Bearing Mounting Position</div>
                  <div className="DetailsValue">
                    : {item.bearing_mounting_position_name}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Bearing Mounting Technique</div>
                  <div className="DetailsValue">
                    : {item.bearing_mounting_technique_name}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Shaft Orientation</div>
                  <div className="DetailsValue">
                    : {item.shaft_orientation_name}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Shaft Material</div>
                  <div className="DetailsValue">
                    : {item.shaft_material_name}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Housing Type</div>
                  <div className="DetailsValue">: {item.housing_type_name}</div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Housing Material</div>
                  <div className="DetailsValue">
                    : {item.housing_material_name}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">Shaft/Housing Sealing</div>
                  <div className="DetailsValue">
                    : {item.shaft_housing_sealing}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">ISO Shaft Fits & Tolerance</div>
                  <div className="DetailsValue">
                    : {item.iso_shaft_fits_tolerance}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">
                    ISO Housing Fits & Tolerance
                  </div>
                  <div className="DetailsValue">
                    : {item.iso_housing_fits_tolerance}
                  </div>
                </div>
                <div className="DetailsRow">
                  <div className="DetailsLabel">
                    Additional Details
                  </div>
                  <div className="DetailsValue">
                    : {item.additional_details}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MachineInformation;
